import { createContext, useState } from 'react';
import { CapturingMapContextType, MapInfo, PAGE } from './types';

export const CapturingMapContext = createContext<CapturingMapContextType>({
    currentStep: PAGE.REGION_SELECTION,
    setCurrentStep: () => {},
    mapInfo: {},
    setMapInfo: () => {}
});

export const CapturingMapContextProvider: React.FC = ({ children }) => {
    const [currentStep, setCurrentStep] = useState(PAGE.REGION_SELECTION);
    const [mapInfo, setMapInfo] = useState<MapInfo>({});

    return (
        <CapturingMapContext.Provider value={{ currentStep, setCurrentStep, mapInfo, setMapInfo }}>{children}</CapturingMapContext.Provider>
    );
};
